import { generateHTML } from '@tiptap/html'
import PropTypes from 'prop-types'
import { useMemo } from 'react'

import { extensions } from '../../constants/tiptap'
import { getAssessmentStartLink, replaceMacros } from '../../helpers'
import { resolveMailTemplateLanguage } from '../../helpers/mail-template-language'
import './mail-template-preview.scss'

function extractSubstringBetween(originalString, fromString, toString) {
  const fromIndex = originalString.indexOf(fromString)
  const toIndex = originalString.indexOf(toString)

  if (fromIndex !== -1 && toIndex !== -1) {
    const substring = originalString.substring(
      fromIndex + fromString.length,
      toIndex
    )

    return substring
  } else {
    throw new Error(
      'extractSubstringBetween - from or to string not found in the original string!'
    )
  }
}

const MailTemplatePreview = ({
  data,
  system,
  imageUrl,
  language,
  useInvitationBlock,
  mailTemplateMacros
}) => {
  const __html = useMemo(() => {
    // use-mail-templates liefert die Sprache schon aufgelöst. Hier nochmal
    // absichern, weil scaffold[nl] ohne Fallback die Vorschau zum Absturz bringt.
    const mailLanguage = resolveMailTemplateLanguage({ system, language })

    let scaffold = `<div ${extractSubstringBetween(
      system.scaffold[mailLanguage],
      '<body ',
      '</body>'
    )}</div>`

    if (useInvitationBlock) {
      const invitationBlock = system.invitationBlock[mailLanguage]
      scaffold = scaffold.replaceAll('{{invitation_block}}', invitationBlock)
      scaffold = replaceMacros({ text: scaffold, macros: mailTemplateMacros })
    } else {
      scaffold = scaffold.replaceAll('{{invitation_block}}', '')
    }

    const content = replaceMacros({
      text: generateHTML(data, extensions),
      macros: mailTemplateMacros
    })

    const withContent = scaffold.replaceAll('{{content}}', content)
    const withImageUrl = withContent.replaceAll('{{image_url}}', imageUrl)
    // Den persönlichen Link gibt es erst beim Versand, bis dahin steht der
    // Start-Link der Webapp da
    const withInvitationLink = withImageUrl.replaceAll(
      '{{invitation_link}}',
      getAssessmentStartLink({ language: mailLanguage })
    )

    return withInvitationLink
  }, [data, mailTemplateMacros, system, language, imageUrl, useInvitationBlock])

  // Links führen in der Vorschau nirgends hin. Ein Klick auf den Start-Button
  // würde sonst die Webapp öffnen, ohne Einladung.
  const blockLinks = (event) => {
    if (event.target.closest?.('a')) event.preventDefault()
  }

  return (
    <div
      className='preview'
      onClickCapture={blockLinks}
      dangerouslySetInnerHTML={{ __html }}
    />
  )
}

MailTemplatePreview.propTypes = {
  data: PropTypes.object.isRequired,
  system: PropTypes.object.isRequired,
  mailTemplateMacros: PropTypes.array.isRequired,
  imageUrl: PropTypes.string,
  language: PropTypes.string.isRequired,
  useInvitationBlock: PropTypes.bool.isRequired
}

MailTemplatePreview.defaultProps = {
  imageUrl:
    'https://aivy-user-content-production.s3.eu-central-1.amazonaws.com/public/partner-logos/af2dabfc-f3ff-43a1-80cd-53ebf3da38d1.png'
}

export default MailTemplatePreview
